export default __webpack_public_path__ + "static/media/goldcoin2.fbbf7d46.png";